<template>
  <div class="students-page">
    <h2 class="page-title">学员课时</h2>
    <p class="page-lead">在这里查每个学员的大课剩余、小课剩余和年卡。充值、开通课程也在本页操作。</p>
    <el-card>
      <div class="toolbar">
        <el-radio-group v-model="courseType" size="small" @change="onFilterChange">
          <el-radio-button :label="0">全部</el-radio-button>
          <el-radio-button :label="1">大课</el-radio-button>
          <el-radio-button :label="2">小课</el-radio-button>
          <el-radio-button :label="3">年卡</el-radio-button>
        </el-radio-group>
        <el-input v-model="keyword" placeholder="搜索学生/家长/电话" clearable @clear="onFilterChange" @keyup.enter.native="onFilterChange">
          <el-button slot="append" icon="el-icon-search" @click="onFilterChange" />
        </el-input>
      </div>

      <!-- 桌面：表格 -->
      <div class="table-desktop">
        <el-table :data="list" v-loading="loading" border stripe>
          <el-table-column prop="name" label="学生姓名" min-width="90" />
          <el-table-column prop="gender" label="性别" width="60">
            <template slot-scope="{ row }">{{ row.gender === 2 ? '女' : '男' }}</template>
          </el-table-column>
          <el-table-column prop="parentName" label="家长" min-width="80" />
          <el-table-column prop="parentPhone" label="电话" min-width="120" />
          <el-table-column prop="remainingHours" label="大课剩余" width="110">
            <template slot-scope="{ row }">
              <span class="hours-num" :class="{ danger: (row.remainingHours || 0) <= 3 && (row.remainingHours || 0) > 0, muted: !row.remainingHours }">{{ row.remainingHours || 0 }}</span>
              <span class="hours-unit">课时</span>
              <el-tag v-if="(row.owedHours || 0) > 0" type="warning" size="mini" class="owed-tag">欠{{ row.owedHours }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="privateRemainingHours" label="小课剩余" width="110">
            <template slot-scope="{ row }">
              <span class="hours-num private" :class="{ danger: (row.privateRemainingHours || 0) <= 3 && (row.privateRemainingHours || 0) > 0, muted: !row.privateRemainingHours }">{{ row.privateRemainingHours || 0 }}</span>
              <span class="hours-unit">课时</span>
              <el-tag v-if="Number(row.privateOwedHours || 0) > 0" type="warning" size="mini" class="owed-tag">欠{{ row.privateOwedHours }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="年卡" min-width="140">
            <template slot-scope="{ row }">
              <el-tag v-if="annualCardLabel(row)" :type="annualCardActive(row) ? 'success' : 'info'" size="small">
                {{ annualCardLabel(row) }}
              </el-tag>
              <span v-else class="hours-unit">未开通</span>
            </template>
          </el-table-column>
          <el-table-column label="抵小课" width="90">
            <template slot-scope="{ row }">
              <el-tag v-if="row.privateExchangeEnabled === 1" type="success" size="small">
                {{ row.privateExchangeRate }}大课=1小课
              </el-tag>
              <span v-else style="color:#C0C4CC">未开通</span>
            </template>
          </el-table-column>
          <el-table-column prop="faceRegistered" label="人脸" width="80">
            <template slot-scope="{ row }">
              <el-tag :type="row.faceRegistered ? 'success' : 'info'" size="small">
                {{ row.faceRegistered ? '已录入' : '未录入' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="110" fixed="right">
            <template slot-scope="{ row }">
              <el-dropdown trigger="click" @command="cmd => handleCommand(cmd, row)">
                <el-button size="mini" type="primary" plain>操作 <i class="el-icon-arrow-down" /></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit">编辑</el-dropdown-item>
                  <el-dropdown-item command="face">{{ row.faceRegistered ? '重录人脸' : '录入人脸' }}</el-dropdown-item>
                  <el-dropdown-item command="recharge">大课充值</el-dropdown-item>
                  <el-dropdown-item command="private">小课充值</el-dropdown-item>
                  <el-dropdown-item command="annual">开通年卡</el-dropdown-item>
                  <el-dropdown-item command="exchange">抵小课</el-dropdown-item>
                  <el-dropdown-item command="deduct">调整课时</el-dropdown-item>
                  <el-dropdown-item command="notify">通知家长</el-dropdown-item>
                  <el-dropdown-item command="delete" divided style="color:#F56C6C">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 手机：卡片列表（避免 fixed 操作列把姓名挤没） -->
      <div class="student-cards" v-loading="loading">
        <div v-if="!loading && !list.length" class="empty-tip">暂无学员</div>
        <div v-for="row in list" :key="row.id" class="student-card">
          <div class="card-top">
            <div>
              <div class="card-name">{{ row.name }}
                <span class="card-gender">{{ row.gender === 2 ? '女' : '男' }}</span>
              </div>
              <div class="card-sub">{{ row.parentName || '-' }} · {{ row.parentPhone || '-' }}</div>
            </div>
            <el-dropdown trigger="click" @command="cmd => handleCommand(cmd, row)">
              <el-button size="mini" type="primary">操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="edit">编辑</el-dropdown-item>
                <el-dropdown-item command="face">{{ row.faceRegistered ? '重录人脸' : '录入人脸' }}</el-dropdown-item>
                <el-dropdown-item command="recharge">大课充值</el-dropdown-item>
                <el-dropdown-item command="private">小课充值</el-dropdown-item>
                <el-dropdown-item command="annual">开通年卡</el-dropdown-item>
                <el-dropdown-item command="exchange">抵小课</el-dropdown-item>
                <el-dropdown-item command="deduct">调整课时</el-dropdown-item>
                <el-dropdown-item command="notify">通知家长</el-dropdown-item>
                <el-dropdown-item command="delete" divided>删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="card-stats">
            <span>大课剩余 <b :class="{ danger: (row.remainingHours || 0) <= 3 }">{{ row.remainingHours || 0 }}</b> 课时</span>
            <span v-if="(row.owedHours || 0) > 0" class="owed-text">大课欠 {{ row.owedHours }}</span>
            <span>小课剩余 <b :class="{ danger: (row.privateRemainingHours || 0) <= 3 }">{{ row.privateRemainingHours || 0 }}</b> 课时</span>
            <span v-if="Number(row.privateOwedHours || 0) > 0" class="owed-text">小课欠 {{ row.privateOwedHours }}</span>
            <el-tag v-if="annualCardLabel(row)" :type="annualCardActive(row) ? 'success' : 'info'" size="mini">{{ annualCardLabel(row) }}</el-tag>
            <el-tag v-if="row.privateExchangeEnabled === 1" type="success" size="mini">{{ row.privateExchangeRate }}大课=1小课</el-tag>
            <el-tag :type="row.faceRegistered ? 'success' : 'info'" size="mini">
              {{ row.faceRegistered ? '已录人脸' : '未录人脸' }}
            </el-tag>
          </div>
        </div>
      </div>

      <el-pagination
        class="pager"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="size"
        :total="total"
        layout="total, prev, pager, next"
        :pager-count="5"
      />
    </el-card>

    <!-- 开通年卡 -->
    <el-dialog title="开通 / 续期年卡" :visible.sync="annualDialogVisible" :width="dialogWidth" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="学生">{{ currentStudent.name }}</el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker v-model="annualForm.cardStart" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker v-model="annualForm.cardEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" style="width:100%" />
        </el-form-item>
        <p class="form-tip">年卡只记有效期。大课、小课都可打卡，余额不够记欠。默认一年，可改。</p>
      </el-form>
      <span slot="footer">
        <el-button @click="annualDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="annualLoading" @click="submitAnnualCard">确认开通</el-button>
      </span>
    </el-dialog>

    <!-- 人脸录入 -->
    <el-dialog
      :title="currentStudent.faceRegistered ? '重新录入人脸' : '录入人脸照片'"
      :visible.sync="faceDialogVisible"
      :width="dialogWidth"
      append-to-body
    >
      <p style="margin-bottom: 12px">学生：{{ currentStudent.name }}</p>
      <input type="file" accept="image/*" capture="user" ref="faceInput" @change="onFaceFileChange" />
      <p style="margin-top: 8px; color: #999; font-size: 12px">手机可直接调起前置摄像头拍照；也可从相册选择清晰正面照</p>
      <div v-if="facePreview" style="margin-top: 12px">
        <img :src="facePreview" style="max-width: 100%; max-height: 300px" />
      </div>
      <span slot="footer">
        <el-button @click="faceDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="faceLoading" @click="submitFace">确认录入</el-button>
      </span>
    </el-dialog>

    <!-- 大课充值 -->
    <el-dialog title="大课充值" :visible.sync="rechargeDialogVisible" :width="dialogWidth" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="学生">{{ currentStudent.name }}</el-form-item>
        <el-form-item label="大课剩余">{{ currentStudent.remainingHours || 0 }} 课时</el-form-item>
        <el-form-item v-if="(currentStudent.owedHours || 0) > 0" label="大课欠课">
          <span class="owed-text">{{ currentStudent.owedHours }} 课时（充值后自动结欠）</span>
        </el-form-item>
        <el-form-item label="充值课时">
          <el-input-number v-model="rechargeForm.hours" :min="1" />
        </el-form-item>
        <el-form-item label="课程包">
          <el-input v-model="rechargeForm.packageName" />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="rechargeForm.amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="rechargeForm.remark" type="textarea" :rows="2" placeholder="选填" maxlength="200" />
        </el-form-item>
        <el-form-item label="凭证附件">
          <el-upload :show-file-list="false" :http-request="uploadRechargeAttach" accept="image/*,.pdf">
            <el-button size="mini">上传凭证</el-button>
          </el-upload>
          <div v-if="rechargeForm.attachmentUrl" style="margin-top:8px">
            <el-link :href="rechargeForm.attachmentUrl" target="_blank" type="primary">预览附件</el-link>
            <el-button type="text" @click="rechargeForm.attachmentUrl=''">清除</el-button>
          </div>
        </el-form-item>
        <el-form-item label="大课抵小课">
          <el-switch v-model="rechargeForm.privateExchangeEnabled" active-text="开通" inactive-text="保持原状" />
          <div class="form-tip">记下比例。签到时教练选择划小课或抵扣；不够默认记欠。</div>
        </el-form-item>
        <el-form-item v-if="rechargeForm.privateExchangeEnabled" label="兑换比例">
          <el-input-number v-model="rechargeForm.privateExchangeRate" :min="2" :max="10" :step="1" />
          <span style="margin-left:8px">节大课 = 1 节小课</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="rechargeDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="rechargeLoading" @click="submitRecharge">确认充值</el-button>
      </span>
    </el-dialog>

    <!-- 大课抵小课开通 -->
    <el-dialog title="开通大课抵小课" :visible.sync="exchangeVisible" :width="dialogWidth" append-to-body>
      <el-form label-width="100px">
        <el-form-item label="学生">{{ currentStudent.name }}</el-form-item>
        <el-form-item label="大课剩余">{{ currentStudent.remainingHours || 0 }} 课时</el-form-item>
        <el-form-item label="开通">
          <el-switch v-model="exchangeForm.enabled" active-text="开通" inactive-text="关闭" />
        </el-form-item>
        <el-form-item v-if="exchangeForm.enabled" label="兑换比例">
          <el-input-number v-model="exchangeForm.rate" :min="2" :max="10" :step="1" />
          <span style="margin-left:8px">节大课 = 1 节小课</span>
        </el-form-item>
        <p class="form-tip">开通后记下比例。签到时由教练选择划小课或大课抵小课；小课不够默认记欠，不会自动抵。</p>
      </el-form>
      <span slot="footer">
        <el-button @click="exchangeVisible = false">取消</el-button>
        <el-button type="primary" :loading="exchangeLoading" @click="submitExchange">保存</el-button>
      </span>
    </el-dialog>

    <!-- 小课开通/充值 -->
    <el-dialog title="开通小课 / 小课充值" :visible.sync="privateRechargeVisible" :width="dialogWidth" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="学生">{{ currentStudent.name }}</el-form-item>
        <el-form-item label="小课剩余">{{ currentStudent.privateRemainingHours || 0 }} 课时</el-form-item>
        <el-form-item v-if="Number(currentStudent.privateOwedHours || 0) > 0" label="小课欠课">
          <span class="owed-text">{{ currentStudent.privateOwedHours }} 课时（充值后自动结欠）</span>
        </el-form-item>
        <el-form-item label="充值课时">
          <el-input-number v-model="privateRechargeForm.hours" :min="1" />
        </el-form-item>
        <el-form-item label="课程包">
          <el-input v-model="privateRechargeForm.packageName" />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="privateRechargeForm.amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="privateRechargeForm.remark" type="textarea" :rows="2" placeholder="选填" maxlength="200" />
        </el-form-item>
        <el-form-item label="凭证附件">
          <el-upload :show-file-list="false" :http-request="uploadPrivateAttach" accept="image/*,.pdf">
            <el-button size="mini">上传凭证</el-button>
          </el-upload>
          <div v-if="privateRechargeForm.attachmentUrl" style="margin-top:8px">
            <el-link :href="privateRechargeForm.attachmentUrl" target="_blank" type="primary">预览附件</el-link>
            <el-button type="text" @click="privateRechargeForm.attachmentUrl=''">清除</el-button>
          </div>
        </el-form-item>
        <el-form-item label="带课教练">
          <el-select v-model="privateRechargeForm.privateCoachId" filterable clearable placeholder="选填，上课教练登录即可划课" style="width:100%">
            <el-option v-for="c in coaches" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="大课抵小课">
          <el-switch v-model="privateRechargeForm.privateExchangeEnabled" active-text="同时开通" />
        </el-form-item>
        <el-form-item v-if="privateRechargeForm.privateExchangeEnabled" label="兑换比例">
          <el-input-number v-model="privateRechargeForm.privateExchangeRate" :min="2" :max="10" :step="1" />
          <span style="margin-left:8px">节大课 = 1 节小课</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="privateRechargeVisible = false">取消</el-button>
        <el-button type="primary" :loading="privateRechargeLoading" @click="submitPrivateRecharge">确认充值</el-button>
      </span>
    </el-dialog>

    <!-- 调整课时：录错可增可减 -->
    <el-dialog title="调整课时" :visible.sync="deductDialogVisible" :width="dialogWidth" append-to-body>
      <el-form label-width="90px">
        <el-form-item label="学生">{{ currentStudent.name }}</el-form-item>
        <el-form-item label="大课剩余">{{ currentStudent.remainingHours || 0 }} 课时</el-form-item>
        <el-form-item label="小课剩余">{{ currentStudent.privateRemainingHours || 0 }} 课时</el-form-item>
        <el-form-item label="调整方式">
          <el-radio-group v-model="deductForm.direction" @change="onDeductDirectionChange">
            <el-radio label="add">增加</el-radio>
            <el-radio label="sub">减少</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="课时类型">
          <el-radio-group v-model="deductForm.courseType" @change="onDeductCourseTypeChange">
            <el-radio :label="1">大课</el-radio>
            <el-radio :label="2">小课</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="deductForm.direction === 'add' ? '增加课时' : '减少课时'">
          <el-input-number
            v-if="deductForm.direction === 'sub' && deductForm.courseType === 2"
            v-model="deductForm.hours"
            :min="0.5"
            :max="Math.max(Number(currentStudent.privateRemainingHours) || 0.5, 0.5)"
            :step="0.5"
            :precision="1"
          />
          <el-input-number
            v-else-if="deductForm.direction === 'sub'"
            v-model="deductForm.hours"
            :min="0.5"
            :max="Math.max(Number(currentStudent.remainingHours) || 0.5, 0.5)"
            :step="0.5"
            :precision="1"
          />
          <el-input-number
            v-else
            v-model="deductForm.hours"
            :min="0.5"
            :max="500"
            :step="0.5"
            :precision="1"
          />
        </el-form-item>
        <el-form-item label="调整原因" required>
          <el-input v-model="deductForm.remark" type="textarea" :rows="2" placeholder="必填，如：录错课时，应充 10 写成了 20" maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="deductDialogVisible = false">取消</el-button>
        <el-button :type="deductForm.direction === 'add' ? 'primary' : 'danger'" :loading="deductLoading" @click="submitDeduct">
          {{ deductForm.direction === 'add' ? '确认增加' : '确认减少' }}
        </el-button>
      </span>
    </el-dialog>

    <!-- 编辑信息 -->
    <el-dialog title="编辑人员信息" :visible.sync="editDialogVisible" :width="dialogWidth" append-to-body>
      <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px">
        <el-divider content-position="left">学生信息</el-divider>
        <el-form-item label="学生姓名" prop="studentName">
          <el-input v-model="editForm.studentName" />
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="editForm.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker v-model="editForm.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
        </el-form-item>
        <el-divider content-position="left">家长信息</el-divider>
        <el-form-item label="家长姓名" prop="parentName">
          <el-input v-model="editForm.parentName" />
        </el-form-item>
        <el-form-item label="联系电话" prop="parentPhone">
          <el-input v-model="editForm.parentPhone" />
        </el-form-item>
        <el-form-item label="关系">
          <el-radio-group v-model="editForm.relation">
            <el-radio label="父亲">父亲</el-radio>
            <el-radio label="母亲">母亲</el-radio>
            <el-radio label="祖父">祖父</el-radio>
            <el-radio label="祖母">祖母</el-radio>
            <el-radio label="监护人">监护人</el-radio>
            <el-radio label="其他">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="editConsent">我确认已向家长说明信息用途，并已获得家长知情同意</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="submitEdit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getStudents, getStudent, registerFace, recharge, adjustHours, deleteStudent, updateStudent, privateRecharge, uploadAdminFile, updatePrivateExchange, listAdminCoaches, openAnnualCard } from '../api'

function ymd(d) {
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function defaultCardRange() {
  const start = new Date()
  const end = new Date()
  end.setFullYear(end.getFullYear() + 1)
  return { cardStart: ymd(start), cardEnd: ymd(end) }
}
function formatDate(val) {
  if (!val) return ''
  if (Array.isArray(val) && val.length >= 3) {
    return val[0] + '-' + String(val[1]).padStart(2, '0') + '-' + String(val[2]).padStart(2, '0')
  }
  return String(val).slice(0, 10)
}

export default {
  name: 'Students',
  data() {
    return {
      loading: false,
      list: [],
      page: 1,
      size: 10,
      total: 0,
      keyword: '',
      courseType: 0,
      faceDialogVisible: false,
      faceLoading: false,
      facePreview: '',
      faceBase64: '',
      currentStudent: {},
      rechargeDialogVisible: false,
      rechargeLoading: false,
      rechargeForm: { hours: 10, packageName: '续费课程包', amount: 0, remark: '', attachmentUrl: '', privateExchangeEnabled: false, privateExchangeRate: 2 },
      privateRechargeVisible: false,
      privateRechargeLoading: false,
      privateRechargeForm: { hours: 10, packageName: '小课充值', amount: 0, remark: '', attachmentUrl: '', privateExchangeEnabled: false, privateExchangeRate: 2, privateCoachId: null },
      coaches: [],
      exchangeVisible: false,
      exchangeLoading: false,
      exchangeForm: { enabled: false, rate: 2 },
      annualDialogVisible: false,
      annualLoading: false,
      annualForm: { cardStart: '', cardEnd: '' },
      deductDialogVisible: false,
      deductLoading: false,
      deductForm: { hours: 1, remark: '', courseType: 1, direction: 'sub' },
      deductCanGroup: false,
      deductCanPrivate: false,
      editDialogVisible: false,
      editLoading: false,
      editConsent: false,
      editForm: {
        studentName: '',
        gender: 1,
        birthday: '',
        parentName: '',
        parentPhone: '',
        relation: '父亲',
        remark: ''
      },
      editRules: {
        studentName: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
        parentName: [{ required: true, message: '请输入家长姓名', trigger: 'blur' }],
        parentPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    dialogWidth() {
      if (typeof window === 'undefined') return '560px'
      return window.innerWidth <= 768 ? '92%' : '560px'
    }
  },
  created() {
    this.loadData()
    this.loadCoaches()
    this.openFaceFromQuery()
  },
  methods: {
    async openFaceFromQuery() {
      const id = this.$route.query && this.$route.query.faceStudentId
      if (!id) return
      try {
        const res = await getStudent(id)
        if (res.data) this.openFaceDialog(res.data)
      } catch (e) {}
      const q = { ...this.$route.query }
      delete q.faceStudentId
      this.$router.replace({ path: '/students', query: q })
    },
    handleCommand(cmd, row) {
      const map = {
        edit: () => this.openEditDialog(row),
        face: () => this.openFaceDialog(row),
        recharge: () => this.openRechargeDialog(row),
        exchange: () => this.openExchangeDialog(row),
        private: () => this.goPrivateRecharge(row),
        annual: () => this.openAnnualDialog(row),
        deduct: () => this.openDeductDialog(row),
        notify: () => this.goNotify(row),
        delete: () => this.handleDelete(row)
      }
      const fn = map[cmd]
      if (fn) fn()
    },
    async loadData() {
      this.loading = true
      try {
        const res = await getStudents({ page: this.page, size: this.size, keyword: this.keyword, courseType: this.courseType })
        this.list = res.data.records
        this.total = res.data.total
      } finally {
        this.loading = false
      }
    },
    handlePageChange(p) {
      this.page = p
      this.loadData()
    },
    onFilterChange() {
      this.page = 1
      this.loadData()
    },
    formatDate,
    annualCardActive(row) {
      const start = formatDate(row.annualCardStart)
      const end = formatDate(row.annualCardEnd)
      if (!start || !end) return false
      const today = ymd(new Date())
      return today >= start && today <= end
    },
    annualCardLabel(row) {
      const end = formatDate(row.annualCardEnd)
      if (!end) return ''
      return (this.annualCardActive(row) ? '有效至 ' : '已过期 ') + end
    },
    openAnnualDialog(row) {
      this.currentStudent = row
      const range = defaultCardRange()
      this.annualForm = {
        cardStart: formatDate(row.annualCardStart) || range.cardStart,
        cardEnd: formatDate(row.annualCardEnd) || range.cardEnd
      }
      this.annualDialogVisible = true
    },
    async submitAnnualCard() {
      if (!this.annualForm.cardStart || !this.annualForm.cardEnd) {
        this.$message.warning('请选择年卡开始时间和结束时间')
        return
      }
      if (this.annualForm.cardEnd < this.annualForm.cardStart) {
        this.$message.warning('年卡结束日期不能早于开始日期')
        return
      }
      this.annualLoading = true
      try {
        await openAnnualCard(this.currentStudent.id, {
          ...this.annualForm,
          operator: localStorage.getItem('username') || 'admin'
        })
        this.$message.success('年卡已开通')
        this.annualDialogVisible = false
        this.loadData()
      } finally {
        this.annualLoading = false
      }
    },
    openFaceDialog(row) {
      this.currentStudent = row
      this.facePreview = ''
      this.faceBase64 = ''
      if (this.$refs.faceInput) {
        this.$refs.faceInput.value = ''
      }
      this.faceDialogVisible = true
    },
    async openEditDialog(row) {
      this.currentStudent = row
      this.editConsent = false
      this.editLoading = true
      this.editDialogVisible = true
      try {
        const res = await getStudent(row.id)
        const s = res.data
        this.editForm = {
          studentName: s.name,
          gender: s.gender || 1,
          birthday: s.birthday || '',
          parentName: s.parentName || '',
          parentPhone: s.parentPhone || '',
          relation: s.parentRelation || '父亲',
          remark: s.remark || ''
        }
      } finally {
        this.editLoading = false
      }
    },
    submitEdit() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return
        if (!this.editConsent) {
          this.$message.warning('请勾选家长知情同意')
          return
        }
        this.editLoading = true
        try {
          await updateStudent(this.currentStudent.id, this.editForm)
          this.$message.success('保存成功')
          this.editDialogVisible = false
          this.loadData()
        } finally {
          this.editLoading = false
        }
      })
    },
    onFaceFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      const reader = new FileReader()
      reader.onload = () => {
        this.facePreview = reader.result
        this.faceBase64 = reader.result
      }
      reader.readAsDataURL(file)
    },
    async submitFace() {
      if (!this.faceBase64) {
        this.$message.warning('请先选择人脸照片')
        return
      }
      this.faceLoading = true
      try {
        await registerFace(this.currentStudent.id, this.faceBase64)
        this.$message.success('人脸录入成功')
        this.faceDialogVisible = false
        this.loadData()
      } finally {
        this.faceLoading = false
      }
    },
    openRechargeDialog(row) {
      this.currentStudent = row
      this.rechargeForm = {
        hours: 10,
        packageName: '续费课程包',
        amount: 0,
        remark: '',
        attachmentUrl: '',
        privateExchangeEnabled: row.privateExchangeEnabled === 1,
        privateExchangeRate: row.privateExchangeRate >= 2 ? row.privateExchangeRate : 2
      }
      this.rechargeDialogVisible = true
    },
    openExchangeDialog(row) {
      this.currentStudent = row
      this.exchangeForm = {
        enabled: row.privateExchangeEnabled === 1,
        rate: row.privateExchangeRate >= 2 ? row.privateExchangeRate : 2
      }
      this.exchangeVisible = true
    },
    async submitExchange() {
      this.exchangeLoading = true
      try {
        await updatePrivateExchange(this.currentStudent.id, {
          enabled: this.exchangeForm.enabled,
          rate: this.exchangeForm.rate
        })
        this.$message.success(this.exchangeForm.enabled ? '已开通大课抵小课' : '已关闭')
        this.exchangeVisible = false
        this.loadData()
      } finally {
        this.exchangeLoading = false
      }
    },
    async loadCoaches() {
      try {
        const res = await listAdminCoaches({ page: 1, size: 50 })
        this.coaches = ((res.data && res.data.records) || []).filter(c => c.hasLoginAccount || c.adminUserId)
      } catch (e) {}
    },
    goPrivateRecharge(row) {
      this.currentStudent = row
      this.privateRechargeForm = {
        hours: 10,
        packageName: '小课充值',
        amount: 0,
        remark: '',
        attachmentUrl: '',
        privateExchangeEnabled: false,
        privateExchangeRate: 2,
        privateCoachId: row.privateCoachId || null
      }
      this.privateRechargeVisible = true
    },
    goNotify(row) {
      this.$router.push({
        path: '/notify',
        query: {
          scope: 'one',
          id: row.id,
          name: encodeURIComponent(row.name || ''),
          remaining: row.remainingHours || 0
        }
      })
    },
    async uploadRechargeAttach({ file }) {
      const res = await uploadAdminFile(file)
      this.$set(this.rechargeForm, 'attachmentUrl', res.data.url)
      this.$message.success('凭证已上传')
    },
    async uploadPrivateAttach({ file }) {
      const res = await uploadAdminFile(file)
      this.$set(this.privateRechargeForm, 'attachmentUrl', res.data.url)
      this.$message.success('凭证已上传')
    },
    async submitPrivateRecharge() {
      this.privateRechargeLoading = true
      try {
        const payload = { ...this.privateRechargeForm }
        if (!payload.privateExchangeEnabled) {
          delete payload.privateExchangeEnabled
          delete payload.privateExchangeRate
        }
        const res = await privateRecharge(this.currentStudent.id, payload)
        this.$alert((res.data && res.data.message) || '小课充值成功', '充值成功')
        this.privateRechargeVisible = false
        this.loadData()
      } finally {
        this.privateRechargeLoading = false
      }
    },
    async submitRecharge() {
      this.rechargeLoading = true
      try {
        const payload = { ...this.rechargeForm }
        if (!payload.privateExchangeEnabled) {
          delete payload.privateExchangeEnabled
          delete payload.privateExchangeRate
        }
        const res = await recharge(this.currentStudent.id, payload)
        this.$alert((res.data && res.data.message) || '充值成功', '充值成功')
        this.rechargeDialogVisible = false
        this.loadData()
      } finally {
        this.rechargeLoading = false
      }
    },
    openDeductDialog(row) {
      this.currentStudent = row
      this.deductForm = { hours: 1, remark: '', courseType: 1, direction: 'sub' }
      this.deductDialogVisible = true
    },
    onDeductCourseTypeChange() {
      this.deductForm.hours = 1
    },
    onDeductDirectionChange() {
      this.deductForm.hours = 1
    },
    async submitDeduct() {
      const courseType = this.deductForm.courseType === 2 ? 2 : 1
      const direction = this.deductForm.direction === 'add' ? 'add' : 'sub'
      const rem = courseType === 2
        ? (Number(this.currentStudent.privateRemainingHours) || 0)
        : (Number(this.currentStudent.remainingHours) || 0)
      const hours = Number(this.deductForm.hours)
      const remark = (this.deductForm.remark || '').trim()
      if (!remark) {
        this.$message.warning('请填写调整原因')
        return
      }
      const max = direction === 'add' ? 500 : 100
      if (!Number.isFinite(hours) || hours < 0.5 || hours > max || Math.abs(hours * 2 - Math.round(hours * 2)) > 0.001) {
        this.$message.warning(`请输入 0.5～${max}，且为 0.5 的倍数`)
        return
      }
      if (direction === 'sub' && hours > rem) {
        this.$message.warning('减少课时不能大于剩余课时')
        return
      }
      this.deductLoading = true
      try {
        const res = await adjustHours(this.currentStudent.id, {
          hours: Number(hours.toFixed(1)),
          remark,
          courseType,
          direction
        })
        this.$message.success((res.data && res.data.message) || '调整成功')
        this.deductDialogVisible = false
        this.loadData()
      } finally {
        this.deductLoading = false
      }
    },
    handleDelete(row) {
      this.$confirm(`确定删除学生「${row.name}」及其录入信息吗？删除后不可恢复。`, '删除确认', {
        type: 'warning',
        confirmButtonText: '确定删除',
        cancelButtonText: '取消'
      }).then(async () => {
        await deleteStudent(row.id)
        this.$message.success('删除成功')
        this.loadData()
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 8px; }
.page-lead { margin: 0 0 16px; color: #64748b; font-size: 13px; }
.toolbar { margin-bottom: 16px; display: flex; flex-wrap: wrap; gap: 12px; align-items: center; }
.toolbar .el-input { max-width: 320px; width: 100%; }
.hours-num { font-size: 20px; font-weight: 700; color: #0F766E; }
.hours-num.private { color: #2563EB; }
.hours-num.danger { color: #F56C6C; }
.hours-num.muted { color: #94A3B8; font-weight: 600; }
.hours-unit { margin-left: 4px; font-size: 12px; color: #94A3B8; }
.owed-tag { margin-left: 6px; }
.owed-text { color: #E6A23C; font-weight: 600; font-size: 13px; }
.pager { margin-top: 16px; text-align: right; }
.form-tip { color: #909399; font-size: 12px; line-height: 1.5; margin: 0 0 0 20px; }
.student-cards { display: none; }
.empty-tip { text-align: center; color: #909399; padding: 32px 0; }
.student-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 10px;
  background: #fff;
}
.card-top { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; }
.card-name { font-size: 16px; font-weight: 600; color: #303133; }
.card-gender { margin-left: 6px; font-size: 12px; font-weight: 400; color: #909399; }
.card-sub { margin-top: 4px; font-size: 13px; color: #606266; }
.card-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin-top: 10px;
  font-size: 13px;
  color: #606266;
  align-items: center;
}
.card-stats b { color: #303133; }
.card-stats b.danger { color: #F56C6C; }
@media (max-width: 768px) {
  .toolbar .el-input { max-width: 100%; }
  .table-desktop { display: none; }
  .student-cards { display: block; }
  .pager { text-align: center; }
}
</style>
